import React from 'react'
import wavemakerLogo from "../static/login-asset/wm-logo.svg";

const Logo: React.FC = () => {
  return (
    <div className="login-header-logo">
      <a
        href="https://www.wavemaker.com"
        target="_blank"
        rel="noopener noreferrer"
        className="logoLink"
      >
        <img
          src={wavemakerLogo}
          width="auto"
          height="28px"
          alt="WaveMaker Logo"
        />
      </a>
    </div>
  )
}
export default Logo; 